import React, {Fragment, useContext, useEffect, useState} from "react";
import {Button, Card, Form, ListGroup, Modal, Nav, Spinner, Table,} from "react-bootstrap";
import "../../App.css";
import {TsAdminContext} from "../../context/ts-admin";
import {toast} from "react-toastify";
import syncIcon from "../../assets/icons/sync_icon.svg";
import connected from "../../assets/icons/connect-icon.svg";
import disconnect from "../../assets/icons/disconnect-icon.svg";
import infomationIcon from "../../assets/icons/infomation_icon.svg";
import infomationGuildIcon from "../../assets/icons/infomation_guild_icon.svg";
import {
    createStorageProvider,
    disconnectStorageProvider,
    getProviderDetail,
    ProviderData,
    syncImmediately,
    TableField,
    updateStorageProvider,
    updateSyncTime,
} from "../../api-service/storage-provider";
import {TimeField} from "@mui/x-date-pickers/TimeField";
import dayjs from "dayjs";
import FormulaModal from "./formula-input-modal";
import {Checkbox, FormControlLabel} from "@mui/material";
import {CONNECT_TYPE_EX} from "../../common";
import {useNavigate, useSearchParams} from "react-router-dom";
import AccessControlLog from "./access-control-log";

type FormulaValue = {
    index: any;
    convertRule: string;
    notSend: boolean;
};

export function ServerConnectPage() {
    const [orgInfo, _, userInfo] = useContext(TsAdminContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [obtainType, setObtainType] = useState("定期取得");
    const [tableFields, setTableFields] = useState<TableField[]>([
        {
            Name: "社員ID",
            ApiName: "EmpId__c",
            Index: 1,
            Type: "",
            ConvertRule: "",
            NotSend: false,
        },
        {
            Name: "メール",
            ApiName: "Email__c",
            Index: 2,
            Type: "",
            ConvertRule: "",
            NotSend: false,
        },
        // {
        //   Name: "ログキー",
        //   ApiName: "LogKey__c",
        //   Index: 3,
        //   Type: "",
        //   ConvertRule: "",
        //   NotSend: false,
        // },
        {
            Name: "ログ日時",
            ApiName: "LogDate__c",
            Index: 4,
            Type: "",
            ConvertRule: "",
            NotSend: false,
        },
        {
            Name: "ログ種別",
            ApiName: "LogType__c",
            Index: 5,
            Type: "",
            ConvertRule: "",
            NotSend: false,
        },
        {
            Name: "備考",
            ApiName: "Note__c",
            Index: 6,
            Type: "",
            ConvertRule: "",
            NotSend: false,
        },
        // {
        //   Name: "処理対象フラグ",
        //   ApiName: "ProcessedFlag__c",
        //   Index: 7,
        //   Type: "",
        //   ConvertRule: "",
        //   NotSend: false,
        // },
        {
            Name: "社員コード	",
            ApiName: "EmpCode__c",
            Index: 8,
            Type: "",
            ConvertRule: "",
            NotSend: false,
        },
    ]);

    const [isEditing, setIsEdting] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);
    const [isShowOptionChangeModal, setIsShowOptionChangeModal] = useState(false);
    const [isShowDisconnectModal, setIsShowDisconnectModal] = useState(false);
    const [modalContent, setModalContent] = useState(
        `手動で、データの取得・送信を実行します。\n よろしいですか？`,
    );
    const [isShowDataExplainModal, setIsShowDataExplainModal] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [isSynced, setIsSynced] = useState(false);
    const [isRendered, setIsRendered] = useState(false);
    const [hasHeaderCsv, setHasHeaderCsv] = useState(false);
    const [awsFields, setAwsFields] = useState([
        {name: "access_key", label: "Access Key ID", value: ""},
        {name: "secret_key", label: "Secret Access Key", value: ""},
        {name: "region", label: "Region", value: ""},
        {name: "bucket", label: "Bucket", value: ""},
        {name: "path", label: "Prefix/Path", value: ""},
    ]);
    const [requestBody, setRequestBody] = useState<{
        access_key: string | null;
        secret_key: string | null;
        provider: "aws" | null;
        path: string | null;
        bucket: string | null;
        region: string | null;
        data_source: "s3" | "window";
    }>({
        access_key: "",
        secret_key: "",
        provider: "aws",
        path: "",
        bucket: "",
        region: "",
        data_source: "window",
    });

    const [isRegistering, setIsRegistering] = useState<boolean | null>(null);
    const [fieldErrors, setFieldErrors] = useState<Record<string, boolean>>({});
    const [providerData, setProviderData] = useState<ProviderData | null>(null);
    const [scheduleTime, setScheduleTime] = useState<{
        hour: string;
        minute: string;
    } | null>(null);
    const [timeValue, setTimeValue] = useState<dayjs.Dayjs | null>(null);
    const [duplicateIndexes, setDuplicateIndexes] = useState<number[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [currentFormula, setCurrentFormula] = useState<FormulaValue>({
        index: undefined,
        convertRule: "",
        notSend: false,
    });
    const [initialFormula, setInitialFormula] = useState<
        Record<string, FormulaValue>
    >({});
    const [currentField, setCurrentField] = useState<string | null>(null);
    const [selectingOption, setSelectingOption] = useState<string | null>(null);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab') || 'settings';
    const tab: 'settings' | 'logs' = tabParam === 'settings' || tabParam === 'logs' ? tabParam : 'settings';
    const [activeTab, setActiveTab] = useState<"settings" | "logs">(tab);

    useEffect(() => {
        const {Hour, Minute} = providerData || {};
        if (isEditing && Hour && Minute && Hour !== "" && Minute !== "") {
            const time = dayjs(
                `${Hour.padStart(2, "0")}:${Minute.padStart(2, "0")}`,
                "HH:mm",
            );
            setTimeValue(time);
            setScheduleTime({hour: Hour, minute: Minute});
        } else {
            setTimeValue(null);
        }
    }, [isEditing, providerData]);

    useEffect(() => {
        if (
            providerData?.AccessKey === "" &&
            obtainType === "定期取得" &&
            providerData === null
        ) {
            setIsConnected(false);
            setIsEdting(true);
        }
        if (providerData?.Hour === "" && obtainType === "自動受信") {
            setIsConnected(false);
            setIsEdting(true);
        }
    }, [providerData, obtainType]);

    useEffect(() => {
        if (
            providerData?.DataSource === "s3" &&
            obtainType === "定期取得" &&
            providerData.AccessKey &&
            providerData !== null
        ) {
            setIsConnected(true);
        }
        if (
            providerData?.DataSource === "s3" &&
            obtainType === "自動受信" &&
            providerData !== null &&
            providerData.AccessKey !== ""
        ) {
            setIsConnected(true);
        }
    }, [obtainType]);

    useEffect(() => {
        if (providerData?.Hour && providerData?.Minute) {
            setTimeValue(
                dayjs(`${providerData.Hour}:${providerData.Minute}`, "HH:mm"),
            );
        } else {
            setTimeValue(dayjs(""));
        }
    }, [providerData]);

    useEffect(() => {
        if (providerData?.TableFields) {
            const initial = providerData.TableFields.reduce((acc, item) => {
                acc[item.ApiName] = {
                    index: 0,
                    convertRule: item.ConvertRule || "",
                    notSend: item.NotSend,
                };
                return acc;
            }, {} as Record<string, FormulaValue>);

            setInitialFormula(initial);

            const updatedFields = providerData.TableFields.map((field) => ({
                ...field,
                ConvertRule: initial[field.ApiName]?.convertRule || "",
                Name:
                    isEditing &&
                    ["EmpId__c", "Email__c", "EmpCode__c"].includes(field.ApiName)
                        ? `*${field.Name}`
                        : field.Name,
            }));

            setTableFields(updatedFields);
        }
    }, [providerData?.TableFields, isEditing]);

    useEffect(() => {
        if (tableFields.length === 0) return;
        const indexCount: Record<number, number> = {};
        tableFields.forEach((field) => {
            indexCount[field.Index] = (indexCount[field.Index] || 0) + 1;
        });
        const duplicates = Object.keys(indexCount)
            .filter((key) => indexCount[+key] > 1)
            .map((key) => +key);

        setDuplicateIndexes(duplicates);
    }, [tableFields, currentFormula]);

    useEffect(() => {
        let mounted = true;
        if (!orgInfo) {
            return;
        }

        let isAbleToAccess = orgInfo.currentAccount.useAccessControl &&
            orgInfo.currentOrg.ConnectType !== CONNECT_TYPE_EX;
        if (Boolean(isAbleToAccess) === false) {
            navigate("/404", {replace: true});
        }

        const fetchProviders = async () => {
            if (!mounted) return;
            setIsLoading(true);
            setIsConnected(false);
            try {
                const provider = await getProviderDetail({
                    TargetOrg: `${localStorage.getItem('target-org') || orgInfo?.currentOrg?.OrgId}`,
                });
                const data = provider?.data ?? null;

                if (!data || Object.keys(data).length === 0) {
                    if (!mounted) return;
                    setIsEdting(true);
                    setIsConnected(false);
                    setIsRendered(true);
                    return;
                }

                if (!mounted) return;
                setProviderData(data);

                const hourRaw = data.Hour ?? "";
                const minuteRaw = data.Minute ?? "";
                const hourStr =
                    hourRaw === "" ? "00" : String(hourRaw).padStart(2, "0");
                const minuteStr =
                    minuteRaw === "" ? "00" : String(minuteRaw).padStart(2, "0");
                const hourNum = Number(hourRaw);
                const minuteNum = Number(minuteRaw);
                setHasHeaderCsv(data.HasHeaderCsv);
                if (data.DataSource === "window") {
                    setObtainType(hourRaw === "" ? "定期取得" : "自動受信");
                    setScheduleTime({hour: hourStr, minute: minuteStr});
                    setRequestBody((prev) => ({
                        ...prev,
                        data_source: "window",
                        access_key: data.AccessKey,
                        secret_key: data.SecretKey,
                        bucket: data.Bucket,
                        path: data.Path,
                        provider: "aws",
                        region: data.Region,
                        has_header_csv: data.HasHeaderCsv,
                    }));
                    setIsConnected(true);
                    setIsEdting(false);
                    setIsRegistering(false);
                    if (data.AccessKey === "" && data.Hour === "") {
                        data.DataSource = "s3";
                        setIsConnected(false);
                        setIsEdting(true);
                        setIsRegistering(false);
                    }
                } else if (data.DataSource === "s3") {
                    setAwsFields((prev) =>
                        prev.map((field) => ({
                            ...field,
                            value: getValueFromProvider(field.name, data),
                        })),
                    );
                    setRequestBody((prev) => ({
                        ...prev,
                        data_source: "s3",
                        region: data.Region,
                        access_key: data.AccessKey,
                        secret_key: data.SecretKey,
                        path: data.Path,
                        bucket: data.Bucket,
                        has_header_csv: data.HasHeaderCsv,
                    }));
                    if (data.AccessKey !== "") {
                        setIsConnected(true);
                    } else if (data.AccessKey === "") {
                        setIsConnected(false);
                    }
                    setIsRegistering(false);
                    if (
                        !Number.isNaN(hourNum) &&
                        !Number.isNaN(minuteNum) &&
                        data.AccessKey !== ""
                    ) {
                        setScheduleTime({hour: hourStr, minute: minuteStr});
                        setIsEdting(false);
                    } else {
                        setIsEdting(true);
                        setIsConnected(false);
                        setIsRegistering(false);
                    }
                    setRequestBody((prev) => ({...prev, data_source: "s3"}));
                    setIsRegistering(false);
                } else {
                    setIsConnected(false);
                    setIsEdting(true);
                }

                setIsRendered(true);
            } catch (error) {
                console.error("fetchProviders error", error);
                if (!mounted) return;
                setIsRendered(true);
                setIsConnected(false);
                setIsRegistering(false);
                setIsEdting(false);
            } finally {
                if (!mounted) return;
                setIsLoading(false);
            }
        };

        fetchProviders();

        return () => {
            mounted = false;
        };
    }, [orgInfo]);

    useEffect(() => {
        if (obtainType === "定期取得") {
            setRequestBody((prev) => ({
                ...prev,
                data_source: "s3",
            }));
        } else if (obtainType === "自動受信") {
            setRequestBody((prev) => ({
                ...prev,
                data_source: "window",
            }));
        }
        setFieldErrors({});
    }, [obtainType]);

    useEffect(() => {
        if (userInfo) {
            setIsSuperAdmin(userInfo.isSuperAdmin);
        }
    }, [userInfo]);

    useEffect(() => {
        setActiveTab(tab);
        searchParams.set('tab', tab);
    }, [tab]);

    const getValueFromProvider = (
        fieldName: string,
        data: ProviderData,
    ): string => {
        switch (fieldName) {
            case "access_key":
                return data.AccessKey || "";
            case "secret_key":
                return data.SecretKey || "";
            case "region":
                return data.Region || "";
            case "bucket":
                return data.Bucket || "";
            case "path":
                return data.Path || "";
            default:
                return "";
        }
    };

    const handleCloseModal = () => {
        setIsSynced(false);
        setIsShowModal(false);
        setModalContent(
            "手動で、データの取得・送信を実行します。\n よろしいですか？",
        );
    };

    const handleCloseOptionChangeModal = () => {
        setIsShowOptionChangeModal(false);
    };

    const handleCloseDisconnectModal = () => {
        setIsShowDisconnectModal(false);
    };

    const handleDisconnectAWS = async () => {
        setIsShowDisconnectModal(false);
        setIsLoading(true);
        try {
            const res = await disconnectStorageProvider();
            if (res?.message) {
                toast.success(res?.message);
                setIsConnected(false);
                setIsRegistering(false);
                setAwsFields((prevFields) =>
                    prevFields.map((field) => ({
                        ...field,
                        value: "",
                    })),
                );
                setScheduleTime(null);
                setProviderData(res.data as ProviderData);
                setIsLoading(false);
                setIsEdting(true);
                setIsRegistering(false);
                setIsConnected(false);
            }
        } catch (error) {
            toast.error("ERROR");
            setIsLoading(false);
        }
    };

    const handleCloseDataExplainModal = () => {
        setIsShowDataExplainModal(false);
    };

    const handleSyncImmediately = async () => {
        try {
            setIsLoading(true);
            const sync = await syncImmediately();
            toast.success(sync.message);
            setModalContent("データの取得・送信が完了しました。");
            setIsSynced(true);
        } catch (error) {
            if (error instanceof Error) {
                toast.error(error.message);
            } else {
                toast.error(String(error));
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleRegister = () => {
        if (providerData?.AccessKey === "" || !providerData) {
            setRequestBody((prev) => ({
                ...prev,
                access_key: providerData?.AccessKey || null,
                secret_key: "",
                provider: "aws" as const,
                path: "",
                bucket: "",
                region: "",
                data_source: "s3",
            }));
            setAwsFields((prevFields) =>
                prevFields.map((field) => ({
                    ...field,
                    value: "",
                })),
            );
            setIsRegistering(true);
        } else if (isConnected && providerData?.AccessKey !== "") {
            setIsShowDisconnectModal(true);
        }
    };

    const validateRequiredFields = () => {
        const requiredFields: { key: keyof typeof requestBody; label: string }[] = [
            {key: "access_key", label: "Access Key"},
            {key: "secret_key", label: "Secret Key"},
            {key: "region", label: "Region"},
            {key: "bucket", label: "Bucket"},
            {key: "path", label: "Prefix/Path"},
        ];

        const errors: Record<string, boolean> = {};
        let hasError = false;

        for (const field of requiredFields) {
            const value = requestBody[field.key];
            if (typeof value !== "string" || value.trim() === "") {
                errors[field.key] = true;
                hasError = true;
            }
        }

        setFieldErrors(errors);
        return !hasError;
    };

    const handleCreateStorage = async () => {
        if (!validateRequiredFields()) {
            return;
        }
        try {
            setIsLoading(true);
            setIsRegistering(true);
            if (!providerData?.OrgId || providerData?.OrgId == null) {
                const res = (await createStorageProvider(requestBody)) as {
                    message: string;
                    data: Record<string, any>;
                };
                if (res?.message && res?.data) {
                    toast.success(res.message);
                    setIsConnected(true);
                    setIsRegistering(false);
                    setProviderData(res.data as ProviderData);
                    setObtainType("定期取得");
                }
            } else {
                const res = (await updateStorageProvider(requestBody)) as {
                    message: string;
                    data: Record<string, any>;
                };
                if (res?.message && res?.data) {
                    toast.success(res.message);
                    setIsConnected(true);
                    setIsRegistering(false);
                    setObtainType("定期取得");
                    setProviderData(res?.data as ProviderData);
                }
            }
            setIsLoading(false);
        } catch (e) {
            setIsEdting(false);
            setIsConnected(false);
            setIsLoading(false);
            toast.error(JSON.stringify(e));
        }
    };

    const handleSaveConnection = async () => {
        if (!scheduleTime?.hour && !scheduleTime?.minute) {
            toast.error("送信設定時間を入力してください。");
            return;
        }
        if (duplicateIndexes.length > 0) {
            toast.error(`取得列が重複しています: ${duplicateIndexes.join(", ")}。`);
            return;
        }
        setIsLoading(true);
        try {
            if (providerData !== null) {
                const payload: any = {
                    data_source: obtainType === "s3" ? "s3" : "window",
                    hour: String(scheduleTime?.hour ?? ""),
                    minute: String(scheduleTime?.minute ?? ""),
                };
                payload.table_fields = tableFields;
                payload.has_header_csv = hasHeaderCsv;
                const res = await updateSyncTime(payload);
                if (res?.data) {
                    if (obtainType === "自動受信") {
                        const bodyWithTime = {
                            ...requestBody,
                            hour: scheduleTime?.hour || "",
                            minute: scheduleTime?.minute || "",
                        };
                        if (!providerData.OrgId) {
                            await createStorageProvider(bodyWithTime);
                        } else {
                            await updateStorageProvider(bodyWithTime);
                        }
                        setProviderData((prev) => {
                            const newData = res.data;
                            return {
                                ...newData,
                                AccessKey: prev?.AccessKey || "",
                                DataSource: "window",
                            };
                        });
                    } else {
                        let res;
                        if (providerData.OrgId === "") {
                            res = await createStorageProvider(requestBody);
                        } else {
                            res = await updateStorageProvider(requestBody);
                        }
                        setProviderData(res.data);
                    }

                    setIsEdting(false);
                    setIsRegistering(false);
                    setIsConnected(true);
                    toast.success(res.message);
                }
            } else {
                const payload: any = {
                    data_source: obtainType === "s3" ? "s3" : "window",
                    hour: String(scheduleTime?.hour ?? ""),
                    minute: String(scheduleTime?.minute ?? ""),
                };
                payload.table_fields = tableFields;
                const res = (await createStorageProvider(payload)) as {
                    message: string;
                    data: ProviderData;
                };
                setProviderData(res.data);
                setIsEdting(false);
                setIsRegistering(false);
                setIsConnected(true);
                toast.success("送信設定時間を更新しました。");
            }

            setIsLoading(false);
        } catch (error: unknown) {
            setIsLoading(false);

            if (typeof error === "object" && error !== null && "message" in error) {
                toast.error(String((error as { message: string }).message));
            } else if (error instanceof Error) {
                toast.error(error.message);
            } else {
                toast.error(String(error));
            }
        }
    };

    const handleOpenFormulaModal = (row: TableField) => {
        setCurrentField(row.ApiName);
        setCurrentFormula({
            index: row.Index ?? undefined,
            convertRule: row.ConvertRule.trim() ?? "",
            notSend: row.NotSend,
        });
        setShowModal(true);
    };

    const handleSaveFormula = (val: FormulaValue) => {
        if (currentField) {
            setTableFields((prev) =>
                prev.map((field) =>
                    field.ApiName === currentField
                        ? {
                            ...field,
                            Index: val.index,
                            ConvertRule: val.convertRule,
                            NotSend: val.notSend,
                        }
                        : field,
                ),
            );
        }
        setShowModal(false);
    };

    const handleConfirmSelectOption = () => {
        if (selectingOption) {
            setObtainType(selectingOption);
            setRequestBody((prev) => ({
                ...prev,
                data_source: selectingOption === "定期取得" ? "s3" : "window",
            }));
            setIsShowOptionChangeModal(false);
        }
    };

    const handleTabChange = (newTab: string) => {
        setActiveTab(newTab as "settings" | "logs");
        setSearchParams({tab: newTab});
    };

    return (
        <div>
            {isLoading && (
                <div className="provider-loading">
                    <Spinner variant="light"/>
                </div>
            )}
            {isRendered && (
                <Fragment>
                    <Modal
                        className="pt-5 storage-cmp"
                        show={isShowModal}
                        onHide={handleCloseModal}
                    >
                        <Modal.Header closeButton>
                            {!isSynced ? (
                                "データの取得・送信"
                            ) : (
                                <>
                                    <img
                                        src={infomationIcon}
                                        alt="info"
                                        className="me-1"
                                        style={{order: 0}}
                                    />
                                    確認
                                </>
                            )}
                        </Modal.Header>
                        <Modal.Body>
                            {modalContent.split("\n").map((line, idx) => (
                                <span key={idx}>
                  {line}
                                    <br/>
                </span>
                            ))}
                        </Modal.Body>
                        <Modal.Footer className="modal-footer">
                            {!isSynced && (
                                <>
                                    <Button
                                        variant="light"
                                        size="sm"
                                        className="modal-btn modal-cancel-btn"
                                        onClick={handleCloseModal}
                                    >
                                        キャンセル
                                    </Button>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        className="modal-btn"
                                        onClick={handleSyncImmediately}
                                    >
                                        実行
                                    </Button>
                                </>
                            )}
                            {isSynced && (
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="modal-btn modal-cancel-btn"
                                    onClick={handleCloseModal}
                                >
                                    OK
                                </Button>
                            )}
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        className="pt-5 storage-cmp"
                        show={isShowOptionChangeModal}
                        onHide={handleCloseOptionChangeModal}
                    >
                        <Modal.Header closeButton>
                            <img
                                src={infomationIcon}
                                alt="info"
                                className="me-1"
                                style={{order: 0}}
                            />
                            確認
                        </Modal.Header>
                        <Modal.Body>
                            <span>取得方法を変更します。</span>
                            <br/>
                            <span style={{order: 1}}>よろしいですか？</span>
                        </Modal.Body>
                        <Modal.Footer className="modal-footer">
                            <>
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="modal-btn modal-cancel-btn"
                                    onClick={handleCloseOptionChangeModal}
                                >
                                    キャンセル
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    className="modal-btn"
                                    onClick={handleConfirmSelectOption}
                                >
                                    変更
                                </Button>
                            </>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        className="pt-5 storage-cmp"
                        show={isShowDisconnectModal}
                        onHide={handleCloseDisconnectModal}
                    >
                        <Modal.Header closeButton>
                            <img
                                src={infomationIcon}
                                alt="info"
                                className="me-1"
                                style={{order: 0}}
                            />
                            確認
                        </Modal.Header>
                        <Modal.Body>
                            接続を解除します。
                            <br/>
                            よろしいですか？
                        </Modal.Body>
                        <Modal.Footer className="modal-footer">
                            <>
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="modal-btn modal-cancel-btn"
                                    onClick={handleCloseDisconnectModal}
                                >
                                    キャンセル
                                </Button>
                                <Button
                                    variant="danger"
                                    size="sm"
                                    className="modal-btn"
                                    onClick={handleDisconnectAWS}
                                >
                                    解除
                                </Button>
                            </>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        className="salesforce-fields-connected_explain_modal"
                        show={isShowDataExplainModal}
                        onHide={handleCloseDataExplainModal}
                        centered
                    >
                        <Modal.Header closeButton>
                            送信データ形式について
                        </Modal.Header>


                        <Modal.Body>
                            <ul className="list-disc pl-4 text-sm text-gray-700">
                                <li>
                                    <div>メール</div>
                                    <div>Salesforceユーザーに登録されているメールアドレス</div>
                                </li>

                                <li>
                                    <div>社員ID</div>
                                    <div>TeamSpiritの勤怠社員オブジェクトのid</div>
                                </li>

                                <li>
                                    <div>社員コード</div>
                                    <div>勤怠社員の社員コード</div>
                                </li>

                                <li>
                                    <div>ログ日時</div>
                                    <div>入館・退館の日時で形式はYYYY-MM-DD HH:MM</div>
                                </li>

                                <li>
                                    <div>ログ種別</div>
                                    <div>入館の場合は1、退館の場合は2</div>
                                </li>
                            </ul>
                        </Modal.Body>


                        <Modal.Footer>
                            <Button
                                variant="light"
                                size="sm"
                                className="modal-btn modal-cancel-btn"
                                onClick={handleCloseDataExplainModal}
                            >
                                閉じる
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <div className="d-flex" style={{minHeight: "100vh"}}>
                        <Nav className="flex-column bg-white p-3 nav-bar-container">
                            <Nav.Link
                                className={activeTab === "settings" ? "active" : ""}
                                onClick={() => handleTabChange("settings")}
                            >
                                設定
                            </Nav.Link>
                            <Nav.Link
                                className={activeTab === "logs" ? "active" : ""}
                                onClick={() => handleTabChange("logs")}
                            >
                                ログ確認
                            </Nav.Link>
                        </Nav>

                        {activeTab === 'settings' ? (<div className="provider-settings flex-grow-1 p-4">
                            <Card className="mt-3 card-container">
                                <Card.Body className="page-title">
                                    入退館のデータの取得・送信の設定
                                </Card.Body>
                            </Card>

                            {((!providerData?.Hour && !providerData?.Minute) ||
                                (providerData?.Hour === "" && providerData?.Minute === "") ||
                                !providerData) && (
                                <>
                                    <div className="mt-3 time-unset-container">
                                        <div>
                                            <img src={infomationGuildIcon} alt="info"/>
                                        </div>
                                        <div>
                      <span>
                        取得の設定を行なってください <br/>
                      </span>

                                            <span>
                        まだ取得設定が行われていません。以下より設定を行い、「保存」を押下してください。
                      </span>
                                        </div>
                                    </div>
                                </>
                            )}

                            {isSuperAdmin || (<div className="d-flex justify-content-end">
                                <Button
                                    className={`bg-white sync-button card-content ${
                                        isEditing ? "button-disabled" : ""
                                    }`}
                                    disabled={isEditing}
                                    onClick={() => {
                                        setIsShowModal(true);
                                    }}
                                >
                                    <img src={syncIcon} alt=""/>
                                    <span>手動でデータ取得・送信を行う</span>
                                </Button>
                            </div>)}

                            <Card className="mt-3 card-container">
                                <Form>
                                    <ListGroup variant="flush">
                                        <div className="align-items-center mt-1"></div>
                                        <ListGroup.Item className="w-100 d-flex align-items-center">
                                            <div className="w-25 py-2 item-label">取得方法</div>
                                            <div className="w-100 d-flex gap-4">
                                                {["定期取得", "自動受信"].map((option) => (
                                                    <div
                                                        key={option}
                                                        className="form-check form-check-inline"
                                                    >
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="obtainType"
                                                            id={`storage-${option}`}
                                                            value={option}
                                                            checked={obtainType === option}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                // For existed data
                                                                if (
                                                                    providerData?.OrgId !== "" &&
                                                                    providerData
                                                                ) {
                                                                    setSelectingOption(val);
                                                                    if (
                                                                        providerData?.DataSource === "s3" &&
                                                                        val === "自動受信" &&
                                                                        providerData.AccessKey !== ""
                                                                    ) {
                                                                        setIsShowOptionChangeModal(true);
                                                                        return;
                                                                    }
                                                                    if (
                                                                        providerData?.DataSource === "window" &&
                                                                        val === "定期取得"
                                                                    ) {
                                                                        setIsShowOptionChangeModal(true);
                                                                        return;
                                                                    } else {
                                                                        setObtainType(val);
                                                                        setRequestBody((prev) => ({
                                                                            ...prev,
                                                                            data_source:
                                                                                val === "定期取得" ? "s3" : "window",
                                                                        }));
                                                                    }
                                                                } else {
                                                                    // For new data
                                                                    setObtainType(val);
                                                                    setRequestBody((prev) => ({
                                                                        ...prev,
                                                                        data_source:
                                                                            val === "定期取得" ? "s3" : "window",
                                                                    }));
                                                                }
                                                            }}
                                                            disabled={!isEditing || isSuperAdmin}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor={`storage-${option}`}
                                                        >
                                                            {option}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </ListGroup.Item>

                                        {obtainType === "定期取得" && (
                                            <ListGroup.Item
                                                className="w-100 d-flex align-items-start relative-container">
                                                <div className="w-25 item-label">接続</div>
                                                <div className="w-100 d-flex flex-column gap-2">
                          <span className="guild-text">
                            取得するサーバー先を設定してください
                          </span>
                                                    <div className="d-flex gap-2 connection-container">
                                                        {isConnected && providerData?.AccessKey !== "" && (
                                                            <>
                                                                <span>AWS</span>
                                                                <span>に接続中</span>
                                                            </>
                                                        )}
                                                        <Button
                                                            disabled={!isEditing || isSuperAdmin}
                                                            className={`bg-white sync-button card-content ${
                                                                !isEditing ? "button-disabled" : ""
                                                            }`}
                                                            onClick={handleRegister}
                                                        >
                                                            <img
                                                                src={
                                                                    providerData?.AccessKey !== "" && isConnected
                                                                        ? connected
                                                                        : disconnect
                                                                }
                                                                alt=""
                                                            />
                                                            <span>
                                {providerData?.AccessKey
                                    ? "接続解除"
                                    : "接続する"}
                              </span>
                                                        </Button>
                                                    </div>

                                                    {!isRegistering &&
                                                        isRegistering !== null &&
                                                        isConnected &&
                                                        providerData?.AccessKey !== "" && (
                                                            <>
                                                                <div>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={hasHeaderCsv}
                                                                                size="small"
                                                                                disabled={!isEditing}
                                                                                onChange={(e) => {
                                                                                    setHasHeaderCsv(e.target.checked);
                                                                                    setRequestBody((prev) => ({
                                                                                        ...prev,
                                                                                        has_header_csv: e.target.checked,
                                                                                    }));
                                                                                }}
                                                                            />
                                                                        }
                                                                        label="ヘッダー行を除く"
                                                                        sx={{
                                                                            "& .MuiFormControlLabel-label": {
                                                                                fontSize: "13px",
                                                                                color: "#181818",
                                                                                fontFamily: "Roboto",
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="d-flex connection-container w-100">
                                                                    <div
                                                                        className="salesforce-fields-connected_container w-100">
                                                                        <span>マッピング項目</span>
                                                                        <div
                                                                            className="salesforce-fields-connected_explain_button"
                                                                            onClick={() => setIsShowDataExplainModal(true)}>送信データ形式について
                                                                        </div>
                                                                        <div
                                                                            className="salesforce-fields-connected_table w-100">
                                                                            <Table
                                                                                className="mb-0 s3-connection-table outer-border-only">
                                                                                <thead
                                                                                    className="connection-list-thead">
                                                                                <tr>
                                                                                    <th
                                                                                        style={{
                                                                                            width: isEditing
                                                                                                ? "20%"
                                                                                                : "35%",
                                                                                            minWidth: "120px",
                                                                                        }}
                                                                                    >
                                                                                        表示ラベル
                                                                                    </th>
                                                                                    <th style={{width: "45%"}}>
                                                                                        API参照名
                                                                                    </th>
                                                                                    <th
                                                                                        className={
                                                                                            !isEditing ? "text-center" : ""
                                                                                        }
                                                                                        style={{
                                                                                            width: isEditing
                                                                                                ? "15%"
                                                                                                : "25%",
                                                                                            minWidth: "80px",
                                                                                        }}
                                                                                    >
                                                                                        取得列
                                                                                    </th>
                                                                                    <th
                                                                                        style={{
                                                                                            width: isEditing
                                                                                                ? "15%"
                                                                                                : "25%",
                                                                                            minWidth: "20rem",
                                                                                        }}
                                                                                    >
                                                                                        変換数式
                                                                                    </th>
                                                                                    {isEditing && (
                                                                                        <th
                                                                                            className="text-center"
                                                                                            style={{width: "10%"}}
                                                                                        ></th>
                                                                                    )}
                                                                                </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                {tableFields?.slice().map((row) => (
                                                                                    <tr key={row.ApiName}>
                                                                                        <td>{row.Name}</td>
                                                                                        <td>
                                                <span className="formula-value-trim api-name-max-length">
                                                  {row.ApiName}
                                                </span>
                                                                                        </td>
                                                                                        <td
                                                                                            className={`not-padding-side ${
                                                                                                !isEditing
                                                                                                    ? "text-center"
                                                                                                    : ""
                                                                                            }`}
                                                                                        >
                                                                                            {isEditing ? (
                                                                                                <div
                                                                                                    title={row.ConvertRule.trim()}
                                                                                                    className={`editing-background padding-l
                                                    ${
                                                                                                        duplicateIndexes.includes(
                                                                                                            row.Index,
                                                                                                        )
                                                                                                            ? "duplicate-index"
                                                                                                            : ""
                                                                                                    }
                                                    ${
                                                                                                        row.NotSend === true
                                                                                                            ? "not-send-bg"
                                                                                                            : ""
                                                                                                    }
                                                  `}
                                                                                                >
                                                                                                    {row.NotSend === true
                                                                                                        ? "送信しない"
                                                                                                        : row.Index || ""}
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div
                                                                                                    className={`formula-value-trim ${
                                                                                                        row.NotSend === true
                                                                                                            ? "mg-left"
                                                                                                            : ""
                                                                                                    }`}
                                                                                                >
                                                                                                    {row.NotSend === true
                                                                                                        ? "送信しない"
                                                                                                        : row.Index || ""}
                                                                                                </div>
                                                                                            )}
                                                                                        </td>
                                                                                        <td
                                                                                            className={`${
                                                                                                !isEditing
                                                                                                    ? ""
                                                                                                    : "not-padding-side"
                                                                                            }`}
                                                                                        >
                                                                                            {isEditing ? (
                                                                                                <div
                                                                                                    title={row.ConvertRule.trim()}
                                                                                                    className={`editing-background ${
                                                                                                        row.NotSend === true
                                                                                                            ? "not-send-bg"
                                                                                                            : ""
                                                                                                    }`}
                                                                                                >
                                                                                                    <div
                                                                                                        className="formula-value formula-value-trim">
                                                                                                        {row.NotSend === true
                                                                                                            ? ""
                                                                                                            : row.ConvertRule.trim() ||
                                                                                                            ""}
                                                                                                    </div>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div
                                                                                                    className="formula-value-trim"
                                                                                                    title={row.ConvertRule.trim()}
                                                                                                >
                                                                                                    {row.NotSend === true
                                                                                                        ? ""
                                                                                                        : row.ConvertRule.trim() ||
                                                                                                        "未設定"}
                                                                                                </div>
                                                                                            )}
                                                                                        </td>
                                                                                        {isEditing && (
                                                                                            <td className="not-padding-side">
                                                                                                <div
                                                                                                    className={`editing-background padding-r ${
                                                                                                        row.NotSend === true
                                                                                                            ? "not-send-bg"
                                                                                                            : ""
                                                                                                    }`}
                                                                                                >
                                                                                                    <Button
                                                                                                        onClick={() =>
                                                                                                            handleOpenFormulaModal(
                                                                                                                row,
                                                                                                            )
                                                                                                        }
                                                                                                        style={{
                                                                                                            height: "32px",
                                                                                                            minWidth: "58px",
                                                                                                            marginRight: "12px",
                                                                                                        }}
                                                                                                        className="edit-index_btn"
                                                                                                        variant="outline-primary"
                                                                                                    >
                                                                                                        編集
                                                                                                    </Button>
                                                                                                </div>
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                ))}
                                                                                </tbody>
                                                                            </Table>
                                                                            {isEditing && (
                                                                                <div
                                                                                    className="salesforce-table-guild-text">
                                                                                    *がついている表示ラベルは、いずれか1つ以上の取得列の設定が必要です。
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                </div>
                                            </ListGroup.Item>
                                        )}

                                        {obtainType === "自動受信" && providerData?.OrgId && (
                                            <ListGroup.Item
                                                className="w-100 d-flex align-items-start relative-container">
                                                <div className="w-25 item-label">接続</div>
                                                <div className="w-100 d-flex flex-column gap-2">
                                                    <div>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={hasHeaderCsv}
                                                                    size="small"
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => {
                                                                        setHasHeaderCsv(e.target.checked);
                                                                        setRequestBody((prev) => ({
                                                                            ...prev,
                                                                            has_header_csv: e.target.checked,
                                                                        }));
                                                                    }}
                                                                />
                                                            }
                                                            label="ヘッダー行を除く"
                                                            sx={{
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "13px",
                                                                    color: "#181818",
                                                                    fontFamily: "Roboto",
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="d-flex connection-container w-100">
                                                        <div className="salesforce-fields-connected_container w-100">
                                                            <span>マッピング項目</span>
                                                            <div className="salesforce-fields-connected_explain_button"
                                                                 onClick={() => setIsShowDataExplainModal(true)}>送信データ形式について
                                                            </div>
                                                            <div className="salesforce-fields-connected_table w-100">
                                                                <Table
                                                                    className="mb-0 s3-connection-table outer-border-only">
                                                                    <thead className="connection-list-thead">
                                                                    <tr>
                                                                        <th
                                                                            style={{
                                                                                width: isEditing ? "20%" : "35%",
                                                                                minWidth: "120px",
                                                                            }}
                                                                        >
                                                                            表示ラベル
                                                                        </th>
                                                                        <th style={{width: "45%"}}>
                                                                            API参照名
                                                                        </th>
                                                                        <th
                                                                            className={
                                                                                !isEditing ? "text-center" : ""
                                                                            }
                                                                            style={{
                                                                                width: isEditing ? "15%" : "25%",
                                                                                minWidth: "80px",
                                                                            }}
                                                                        >
                                                                            取得列
                                                                        </th>
                                                                        <th
                                                                            style={{
                                                                                width: isEditing ? "15%" : "25%",
                                                                                minWidth: "20rem",
                                                                            }}
                                                                        >
                                                                            変換数式
                                                                        </th>
                                                                        {isEditing && (
                                                                            <th
                                                                                className="text-center"
                                                                                style={{width: "10%"}}
                                                                            ></th>
                                                                        )}
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {tableFields?.slice().map((row) => (
                                                                        <tr key={row.ApiName}>
                                                                            <td>{row.Name}</td>
                                                                            <td>
                                          <span
                                              title={row.ApiName}
                                              className="formula-value-trim api-name-max-length"
                                          >
                                            {row.ApiName}
                                          </span>
                                                                            </td>
                                                                            <td
                                                                                className={`not-padding-side ${
                                                                                    !isEditing ? "text-center" : ""
                                                                                }`}
                                                                            >
                                                                                {isEditing ? (
                                                                                    <div
                                                                                        title={row.ConvertRule.trim()}
                                                                                        className={`editing-background padding-l
                                                    ${
                                                                                            duplicateIndexes.includes(
                                                                                                row.Index,
                                                                                            )
                                                                                                ? "duplicate-index"
                                                                                                : ""
                                                                                        }
                                                    ${
                                                                                            row.NotSend === true
                                                                                                ? "not-send-bg"
                                                                                                : ""
                                                                                        }
                                                  `}
                                                                                    >
                                                                                        {row.NotSend === true
                                                                                            ? "送信しない"
                                                                                            : row.Index || ""}
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className={`formula-value-trim ${
                                                                                            row.NotSend === true
                                                                                                ? "mg-left"
                                                                                                : ""
                                                                                        }`}
                                                                                    >
                                                                                        {row.NotSend === true
                                                                                            ? "送信しない"
                                                                                            : row.Index || ""}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            <td
                                                                                className={`${
                                                                                    !isEditing ? "" : "not-padding-side"
                                                                                }`}
                                                                            >
                                                                                {isEditing ? (
                                                                                    <div
                                                                                        title={row.ConvertRule.trim()}
                                                                                        className={`editing-background ${
                                                                                            row.NotSend === true
                                                                                                ? "not-send-bg"
                                                                                                : ""
                                                                                        }`}
                                                                                    >
                                                                                        <div
                                                                                            className="formula-value formula-value-trim">
                                                                                            {row.NotSend === true
                                                                                                ? ""
                                                                                                : row.ConvertRule.trim() ||
                                                                                                ""}
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className="formula-value-trim"
                                                                                        title={row.ConvertRule.trim()}
                                                                                    >
                                                                                        {row.NotSend === true
                                                                                            ? ""
                                                                                            : row.ConvertRule.trim() ||
                                                                                            "未設定"}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            {isEditing && (
                                                                                <td className="not-padding-side">
                                                                                    <div
                                                                                        className={`editing-background padding-r ${
                                                                                            row.NotSend === true
                                                                                                ? "not-send-bg"
                                                                                                : ""
                                                                                        }`}
                                                                                    >
                                                                                        <Button
                                                                                            onClick={() =>
                                                                                                handleOpenFormulaModal(row)
                                                                                            }
                                                                                            style={{
                                                                                                height: "32px",
                                                                                                minWidth: "58px",
                                                                                                marginRight: "12px",
                                                                                            }}
                                                                                            className="edit-index_btn"
                                                                                            variant="outline-primary"
                                                                                        >
                                                                                            編集
                                                                                        </Button>
                                                                                    </div>
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                </Table>
                                                                {isEditing && (
                                                                    <div className="salesforce-table-guild-text">
                                                                        *がついている表示ラベルは、いずれか1つ以上の取得列の設定が必要です。
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ListGroup.Item>
                                        )}

                                        {isRegistering &&
                                            isRegistering !== null &&
                                            obtainType !== "自動受信" && (
                                                <>
                                                    {awsFields.map((item, index) => (
                                                        <ListGroup.Item
                                                            key={index}
                                                            className="w-100 d-flex align-items-center"
                                                        >
                                                            <div className="w-25 py-2 item-label">
                                                                <span className="text-danger">*&nbsp;</span>
                                                                {item.label}
                                                            </div>
                                                            <div className="w-100">
                                                                <Form.Control
                                                                    maxLength={100}
                                                                    className="w-100"
                                                                    size="sm"
                                                                    value={item.value}
                                                                    isInvalid={fieldErrors[item.name]}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value;
                                                                        setAwsFields((prev) => {
                                                                            const updated = [...prev];
                                                                            updated[index].value = newValue;
                                                                            return updated;
                                                                        });

                                                                        setRequestBody((prev) => ({
                                                                            ...prev,
                                                                            [item.name]: newValue,
                                                                        }));

                                                                        setFieldErrors((prev) => ({
                                                                            ...prev,
                                                                            [item.name]: false,
                                                                        }));
                                                                    }}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {item.label} を入力してください。
                                                                </Form.Control.Feedback>
                                                            </div>
                                                        </ListGroup.Item>
                                                    ))}
                                                    {isRegistering &&
                                                        isRegistering !== null &&
                                                        (providerData?.AccessKey === "" ||
                                                            !providerData?.AccessKey) &&
                                                        obtainType === "定期取得" && (
                                                            <ListGroup.Item
                                                                className="d-flex justify-content-center p-4 d-grid gap-3">
                                                                <Button
                                                                    className="connection-cancel-btn cancel-register-form-button"
                                                                    onClick={() => {
                                                                        setIsRegistering(false);
                                                                    }}
                                                                >
                                                                    <span>キャンセル</span>
                                                                </Button>
                                                                <Button
                                                                    className="connection-save-btn"
                                                                    onClick={handleCreateStorage}
                                                                >
                                                                    <span>登録</span>
                                                                </Button>
                                                            </ListGroup.Item>
                                                        )}
                                                </>
                                            )}
                                        {!isRegistering &&
                                            isRegistering !== null &&
                                            obtainType === "定期取得" &&
                                            isEditing &&
                                            providerData?.DataSource === "window" &&
                                            !isConnected && (
                                                <ListGroup.Item
                                                    className="d-flex justify-content-center p-4 d-grid gap-5">
                                                    <div className="d-flex gap-3 justify-content-center">
                                                        <>
                                                            <Button
                                                                className="connection-cancel-btn"
                                                                onClick={() => {
                                                                    setIsEdting(false);
                                                                    setObtainType("自動受信");
                                                                }}
                                                            >
                                                                <span>キャンセル</span>
                                                            </Button>
                                                        </>
                                                    </div>
                                                </ListGroup.Item>
                                            )}

                                        {((isConnected && providerData?.AccessKey !== "") ||
                                            obtainType === "自動受信") && (
                                            <>
                                                <ListGroup.Item className="w-100 d-flex align-items-center">
                                                    <div className="w-25 py-2 item-label">
                                                        <span className="text-danger">*&nbsp;</span>
                                                        送信設定時間
                                                    </div>
                                                    <div className="w-100 d-flex gap-4 time-input-container">
                                                        <span>毎日</span>
                                                        {isEditing ? (
                                                            <TimeField
                                                                sx={{
                                                                    width: 73,
                                                                    "& .MuiInputBase-root": {
                                                                        height: 30,
                                                                        fontSize: 14,
                                                                        padding: 0,
                                                                        minHeight: 30,
                                                                    },
                                                                    "& .MuiPickersInputBase-root": {
                                                                        height: 30,
                                                                        minHeight: 30,
                                                                    },
                                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                                        padding: 0,
                                                                    },
                                                                    "& input": {
                                                                        height: 30,
                                                                        padding: "0 6px",
                                                                    },
                                                                    "& .MuiPickersSectionList-root": {
                                                                        minHeight: 30,
                                                                    },
                                                                    "& .MuiPickersSectionList-sectionContent": {
                                                                        fontSize: 14,
                                                                        lineHeight: "30px",
                                                                    },
                                                                    "& input::placeholder": {
                                                                        color: "transparent",
                                                                    },
                                                                    "& input:focus::placeholder": {
                                                                        color: "inherit",
                                                                    },
                                                                }}
                                                                format="HH:mm"
                                                                ampm={false}
                                                                value={timeValue}
                                                                onChange={(newValue) => {
                                                                    setTimeValue(newValue);
                                                                    if (newValue?.isValid?.()) {
                                                                        setScheduleTime({
                                                                            hour: newValue.format("HH"),
                                                                            minute: newValue.format("mm"),
                                                                        });
                                                                    } else {
                                                                        setScheduleTime(null);
                                                                    }
                                                                }}
                                                                error={false}
                                                                slotProps={{
                                                                    textField: {
                                                                        inputProps: {
                                                                            placeholder: "00:00",
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        ) : providerData?.Hour &&
                                                        providerData?.Minute &&
                                                        isConnected ? (
                                                            <span>
                                {providerData.Hour.padStart(2, "0")}:
                                                                {providerData.Minute.padStart(2, "0")}
                              </span>
                                                        ) : (
                                                            <span></span>
                                                        )}
                                                        <span className="guild-text">
                              にTeamSpiritへデータを送信
                            </span>
                                                    </div>
                                                </ListGroup.Item>
                                            </>
                                        )}
                                        {isConnected &&
                                            obtainType !== "自動受信" &&
                                            !isRegistering && !isSuperAdmin && (
                                                <ListGroup.Item
                                                    className="d-flex justify-content-center p-4 d-grid gap-5">
                                                    <div className="d-flex gap-3 justify-content-center">
                                                        {!isEditing &&
                                                        isConnected &&
                                                        providerData?.Hour !== null &&
                                                        providerData?.Minute !== null &&
                                                        providerData?.OrgId !== "" ? (
                                                            <Button
                                                                className="bg-white edit-button"
                                                                onClick={() => {
                                                                    setIsEdting(true);
                                                                }}
                                                            >
                                                                <span>編集</span>
                                                            </Button>
                                                        ) : (
                                                            <>
                                                                {isConnected &&
                                                                    providerData?.Hour &&
                                                                    providerData?.Minute &&
                                                                    providerData?.OrgId !== "" && (
                                                                        <Button
                                                                            className="connection-cancel-btn"
                                                                            onClick={() => {
                                                                                if (
                                                                                    (providerData.Hour !== "" &&
                                                                                        providerData.AccessKey === "") ||
                                                                                    providerData.DataSource === "window"
                                                                                ) {
                                                                                    setObtainType("自動受信");
                                                                                }
                                                                                setIsEdting(false);
                                                                                setIsRegistering(false);
                                                                            }}
                                                                        >
                                                                            <span>キャンセル</span>
                                                                        </Button>
                                                                    )}
                                                                {providerData?.AccessKey !== "" && (
                                                                    <Button
                                                                        className="connection-save-btn"
                                                                        onClick={handleSaveConnection}
                                                                    >
                                                                        <span>保存</span>
                                                                    </Button>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </ListGroup.Item>
                                            )}
                                        {obtainType === "自動受信" && (
                                            <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-5">
                                                <div className="d-flex gap-3 justify-content-center">
                                                    {!isEditing && !isSuperAdmin &&
                                                    providerData?.Hour !== "" &&
                                                    providerData?.Minute !== "" ? (
                                                        <Button
                                                            className="bg-white edit-button"
                                                            onClick={() => setIsEdting(true)}
                                                        >
                                                            <span>編集</span>
                                                        </Button>
                                                    ) : (
                                                        <>
                                                            {isEditing && (
                                                                <>
                                                                    {isConnected &&
                                                                        providerData?.Hour !== "" &&
                                                                        providerData?.Minute !== "" && (
                                                                            <Button
                                                                                className="connection-cancel-btn"
                                                                                onClick={() => {
                                                                                    setIsEdting(false);
                                                                                    setIsRegistering(false);
                                                                                    if (
                                                                                        providerData?.DataSource === "s3"
                                                                                    ) {
                                                                                        setObtainType("定期取得");
                                                                                        setIsConnected(false);
                                                                                        setIsEdting(false);
                                                                                    }
                                                                                    if (!providerData?.Hour) {
                                                                                        setIsEdting(true);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span>キャンセル</span>
                                                                            </Button>
                                                                        )}
                                                                    <Button
                                                                        className="connection-save-btn"
                                                                        onClick={handleSaveConnection}
                                                                    >
                                                                        <span>保存</span>
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </ListGroup.Item>
                                        )}
                                    </ListGroup>
                                </Form>
                            </Card>
                        </div>) : (<AccessControlLog/>)}
                    </div>
                    {showModal && (
                        <FormulaModal
                            show={showModal}
                            currentField={currentField}
                            onClose={() => setShowModal(false)}
                            value={currentFormula}
                            onChange={(val: FormulaValue) => {
                                setCurrentFormula(val);
                            }}
                            onSave={handleSaveFormula}
                            initialValue={(() => {
                                const val = initialFormula[currentField ?? ""];
                                if (!val)
                                    return {index: undefined, convertRule: "", notSend: false};
                                return typeof val === "string"
                                    ? {index: 999, convertRule: val, notSend: false}
                                    : val;
                            })()}
                        />
                    )}
                </Fragment>
            )}
        </div>
    );
}
